(ns ui.wallet.i18n
  "Translations of the wallet page (/ui/subscription) with m1p:
   https://github.com/cjohansen/m1p

   The page's hiccup carries dictionary references like
   `[:i18n :balance/total-available]` or
   `[:i18n :on-demand/rule {:threshold 5 :amount 20}]`; `translate` walks
   the finished hiccup once and replaces them, which also reaches strings
   inside action vectors (`:js/confirm`) and attributes.

   One dictionary per language lives in `ui.wallet.i18n.<lang>`.
   English is the fallback: every other dictionary is merged on top of it,
   so a missing key shows the English text instead of an error. The
   language comes from the browser (`navigator.languages`), the first one
   with a dictionary wins, or from `:i18n/locale` in the store (portfolio
   scenes, tests)."
  (:require [clojure.string :as str]
            [m1p.core :as m1p]
            [ui.wallet.i18n.de :as de]
            [ui.wallet.i18n.en :as en]
            [ui.wallet.i18n.es :as es]
            [ui.wallet.i18n.fr :as fr]
            [ui.wallet.i18n.it :as it]
            [ui.wallet.i18n.ja :as ja]
            [ui.wallet.i18n.nl :as nl]
            [ui.wallet.i18n.pt :as pt]
            [ui.wallet.i18n.tr :as tr]))

(def raw-dictionaries
  "The plain dictionaries by language, English complete, the others may
   omit keys (see the parity test in ui.wallet.i18n-test)."
  {:en en/dictionary
   :de de/dictionary
   :es es/dictionary
   :fr fr/dictionary
   :it it/dictionary
   :ja ja/dictionary
   :nl nl/dictionary
   :pt pt/dictionary
   :tr tr/dictionary})

(def dictionaries
  (into {}
        (map (fn [[locale dictionary]]
               [locale (m1p/prepare-dictionary [en/dictionary dictionary])]))
        raw-dictionaries))

(defn language-tag->locale
  "\"de-DE\" -> :de, \"pt-BR\" -> :pt; nil for unknown or empty tags."
  [tag]
  (when (string? tag)
    (let [lang (-> tag
                   (str/split #"[-_]")
                   (first)
                   (str/lower-case))]
      (when (seq lang)
        (keyword lang)))))

(defn preferred-locale
  "The first of the browser's preferred languages that has a dictionary,
   English otherwise."
  [language-tags]
  (or (->> language-tags
           (map language-tag->locale)
           (filter #(contains? dictionaries %))
           (first))
      :en))

(defn browser-language-tags
  []
  #?(:cljs (or (some-> js/navigator .-languages (js->clj))
               (some-> js/navigator .-language (vector)))
     :clj nil))

(defn locale
  [state]
  (or (:i18n/locale state)
      (preferred-locale (browser-language-tags))))

(defn on-missing-key
  "Unknown keys keep a `:fallback` given in the params (the server's text of
   a service the dictionaries do not know yet), otherwise they stay visible."
  [_opt params k]
  (or (:fallback params)
      (str "[Missing " k "]")))

(defn translate
  "Replaces every `[:i18n k params]` in `hiccup` for the locale of `state`."
  [state hiccup]
  (m1p/interpolate hiccup
                   {:dictionaries {:i18n (get dictionaries
                                              (locale state)
                                              (:en dictionaries))}
                    :on-missing-dictionary-key on-missing-key}))

(defn service-key
  "The dictionary key of a service text, e.g. `:service.tiktok-post/name`."
  [service-id field]
  (keyword (str "service." (name service-id))
           (name field)))
